"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
interface BracketConnectorProps {
  roundIndex: number;
  tieIndex: number;
}

/**
 * Pure-CSS bracket connector using absolutely-positioned div borders.
 *
 * Draws the classic bracket shape inside its grid cell:
 *
 *   ────┐
 *       ├────
 *   ────┘
 *
 * Top arm at 25%, bottom arm at 75%, exit at 50%.
 * Works because the parent grid-item has `position: relative` and
 * definite dimensions from the CSS Grid, so percentage-based absolute
 * positioning resolves correctly.
 */
export function BracketConnector(t0) {
  const $ = _c(1);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div style={{
      position: "absolute",
      inset: 0,
      opacity: 0.4
    }}><div style={{
        position: "absolute",
        left: 0,
        width: "50%",
        top: "25%",
        borderTop: "1.5px solid var(--border)"
      }} /><div style={{
        position: "absolute",
        left: 0,
        width: "50%",
        top: "75%",
        borderTop: "1.5px solid var(--border)"
      }} /><div style={{
        position: "absolute",
        left: "50%",
        top: "25%",
        height: "50%",
        borderLeft: "1.5px solid var(--border)"
      }} /><div style={{
        position: "absolute",
        left: "50%",
        width: "50%",
        top: "50%",
        borderTop: "1.5px solid var(--border)"
      }} /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  return t1;
}